import mergeVariables from '../../fe-brary-internals/merge-variables';
import base from '../../base';
import typography from './typography';
import palette from './colours/palette';
import tints from './colours/tints';

// prettier-ignore
export default mergeVariables(
// colours
tints, palette,
// typography
base.typography, typography,
// globals
base.grid, base.layers, base.spacing,
// components
base.components.icons, base.components.messages, base.components.form, base.components.input, base.components.buttons, base.components.social)({});